import React, { useContext, useEffect, useState } from 'react';
import { Box, Container, Theme, Typography } from '@material-ui/core';
import DiscussionList from './DiscussionList';
import { makeStyles } from '@material-ui/styles';
import DiscussionTopics from './DiscussionTopics';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import C from '../../../../../shared/constants/general';

const getStyles = makeStyles((theme: Theme) => ({
  topicsList: {
    minWidth: 180,
    borderLeftStyle: 'solid',
    borderLeftWidth: 1,
    borderLeftColor: theme.palette.background.shadedown_20,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  topicsDropdown: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

const menuItems = [
  // {
  //   name: 'all',
  //   title: 'ALL',
  //   api: `/api/visitor/conferences/${window.CONFERENCE_ID}/discussions?`,
  // },
  {
    name: 'my',
    title: 'MY DISCUSSIONS',
    api: `/api/visitor/conferences/${window.CONFERENCE_ID}/mydiscussions?`,
  },
  //   {
  //     name: 'hidden',
  //     title: 'HIDDEN',
  //     moderators: true,
  //     api: `/api/moderator/conferences/${window.CONFERENCE_ID}/hiddendiscussions?state=hidden`,
  //     description:
  //       'As moderator you can hide discussions instead of deleting them',
  //   },
  //   {
  //     name: 'suggested',
  //     title: 'SUGGESTED',
  //     moderators: true,
  //     api: `/api/moderator/conferences/${window.CONFERENCE_ID}/hiddendiscussions?state=suggested`,
  //     description:
  //       'When the event is configured not to allow people to start discussions, they can suggest and moderators can then move them to SHOW',
  //   },
];

export const DiscussionMain = ({
  match: {
    params: { topic: topicSlug = '' },
  },
  ...props
}) => {
  const classes = getStyles();
  const { authState } = useContext(AuthContext); // Hämta Context
  const [topics, setTopics] = useState(null);
  const currentTopic: any =
    topics !== null
      ? topics.find((t: any) => t.slug === topicSlug) || // First find topic by slug
        (!topicSlug && topics.length > 0 && topics[0]) || // Use first topic
        null
      : null;

  const isModerator =
    authState.user.access_level === C.VISITOR.ACCESS_LEVEL.MODERATOR;

  const refresh = () => {
    axios
      .get(
        `/api/visitor/conferences/${
          (window as any).CONFERENCE_ID
        }/discussiontopics`
      )
      .then((response) => {
        setTopics(response.data);
      });
  };

  useEffect(() => {
    refresh();
  }, []);

  // const specialApi =
  //   topicSlug === 'my'
  //     ? `/api/visitor/conferences/${window.CONFERENCE_ID}/mydiscussions?`
  //     : null;

  return (
    topics !== null && (
      <Container maxWidth="lg">
        <Box className={classes.topicsDropdown}>
          <DiscussionTopics
            minimize={true}
            topicSlug={topicSlug}
            topics={topics}
            setTopics={setTopics}
            refresh={refresh}
          />
        </Box>
        <Box display="flex" alignItems="flex-top">
          <Box flexGrow={1}>
            {topics !== null && topics.length === 0 ? (
              <Box textAlign="center" pt={3}>
                Not enabled.
                {isModerator && 'Create a Topic to enable the forum.'}
              </Box>
            ) : (
              <DiscussionList
                listType={
                  topicSlug === 'my' ? 'my' : topicSlug ? 'topic' : 'all'
                }
                topic={currentTopic}
                topicSlug={topicSlug}
                {...props}
              />
            )}
          </Box>
          <Box className={classes.topicsList}>
            <DiscussionTopics
              minimize={false}
              topicSlug={topicSlug}
              topics={topics}
              setTopics={setTopics}
              refresh={refresh}
            />
          </Box>
        </Box>
      </Container>
    )
  );
};

DiscussionMain.displayName = 'DiscussionMain';
